const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g><path d="M21.5 2.5h-19A2.5 2.5 0 0 0 0 5v14a2.5 2.5 0 0 0 2.5 2.5h19A2.5 2.5 0 0 0 24 19V5a2.5 2.5 0 0 0-2.5-2.5ZM11.25 6.92a.75.75 0 0 1 1.5 0v5.5a.75.75 0 1 1-1.5 0Zm.75 11a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Z" fill="currentColor"></path><path fill="currentColor" d="M12 16.42h.75H12z"></path></g></svg>';
export {
  a as default
};
